import React from 'react';
import Container from '@amzn/awsui-components-core/container';
import FormField from '@amzn/awsui-components-core/form-field';
import Header from '@amzn/awsui-components-core/header';
import Select from '@amzn/awsui-components-core/select';
import type { StarGridText } from 'src/components/star-grid/hooks/useStarGridText';
import type { DatasetWizardState } from 'src/components/star-grid/datasets/hooks/useDatasetWizard';
import { effectiveRole } from 'src/components/star-grid/datasets/utils/datasetDraft';
import { withFxMeasure } from 'src/components/star-grid/datasets/utils/datasetCapabilities';

/** Opt-in report features; a dataset with none is plain: each column reads exactly the scenario and months it names. */
export const WizardReportFeatures: React.FC<{ state: DatasetWizardState; text: StarGridText }> = ({ state, text }) => {
  const measures = (state.profile?.columns ?? []).filter((column) => effectiveRole(column, state.roles) === 'measure');
  const { capabilities, setCapabilities } = state;
  const noFx = { value: '', label: text('wizardFeaturesNone') };
  const fxOptions = [noFx, ...measures.map((column) => ({ value: column.name, label: column.name }))];

  return (
    <Container
      header={
        <Header variant="h3" description={text('wizardFeaturesHelp')}>
          {text('wizardFeatures')}
        </Header>
      }
      data-testid="wizard-features"
    >
      <FormField label={text('wizardFeaturesFxMeasure')} description={text('wizardFeaturesFxHelp')}>
        <Select
          expandToViewport
          data-testid="wizard-fx-measure"
          options={fxOptions}
          selectedOption={fxOptions.find((option) => option.value === (capabilities.fx_measure ?? '')) ?? noFx}
          onChange={({ detail }) => setCapabilities(withFxMeasure(capabilities, detail.selectedOption.value))}
        />
      </FormField>
    </Container>
  );
};
